import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import {
  DetailsHeader,
  IconWithText,
  Tooltip,
  WikiLink,
} from '@discretize/gw2-ui-new';
import PropTypes from 'prop-types';
import tooltipData from './tooltipData.json';
import { capitalize } from '@mui/material';

function Gw2Component({ text, type, name, size, disableText }) {
  const data = tooltipData[type][name.toLowerCase()] || {};
  const displayName = disableText
    ? null
    : `${text || (!!data && data.name) || capitalize(name)}`;
  const { description } = data;

  const imageData = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          relativePath: {
            in: [
              "icons/hypernovalaunch.png"
              "icons/lightofdeldrimor.png"
              "icons/kallasfervor.png"
              "icons/chargedleap.png"
              "icons/tidalbargain.png"
              "icons/attackofopportunity.png"
              "icons/battlescars.png"
            ]
          }
        }
      ) {
        nodes {
          childImageSharp {
            gatsbyImageData(width: 48)
          }
          name
        }
      }
    }
  `);

  function findImage({ imageName }) {
    return imageData.allFile.nodes.find((image) => image.name === imageName)
      ?.childImageSharp.gatsbyImageData.images.fallback.src;
  }

  const iconWithText = (
    <IconWithText
      icon={findImage({ imageName: name.toLowerCase() })}
      text={<WikiLink to={displayName} />}
    />
  );

  if (!displayName && !description) {
    return iconWithText;
  }

  return (
    <Tooltip
      content={
        <>
          <DetailsHeader>{displayName}</DetailsHeader>
          {description}
        </>
      }
    >
      {iconWithText}
    </Tooltip>
  );
}

Gw2Component.propTypes = {
  disableText: PropTypes.bool,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  text: PropTypes.string,
  type: PropTypes.string.isRequired,
};

Gw2Component.defaultProps = {
  disableText: false,
  size: 'small',
  text: null,
};

export default Gw2Component;
